import {ColorPalette} from "../../../../fields3/color-coding/color-coding";

export default function ListMulti_getColorCodingStyle(option:any) {
    if (!option.color) return null

    const colorCoding = {
        colorNumber     : option.color,
        corePalette     : ColorPalette.CORE
    }

    return {
        backgroundColor : gd.skin.colors.paleBGColor(colorCoding),
        borderColor     : gd.skin.colors.paleBorderColor(colorCoding)
    }
}